import React from 'react';
import SEO from '../components/SEO';
import './News.css';

const News = () => {
  return (
    <div className="news-container">
      <SEO
        title="News & Updates - NAB India"
        description="Stay up-to-date with the latest news, events, and announcements from the National Association for the Blind (NAB) India. Find out what's happening in our community and how we're making an impact."
        keywords="NAB India news, NAB India updates, events, announcements, visually impaired community news"
      />
      <h1 className="news-heading">News and Updates</h1>
      
      {/* Election Results 2025 Banner */}
      <div className="election-banner">
        <div className="election-banner-content">
          <h2 className="election-banner-title">Election Results 2025</h2>
          <p className="election-banner-text">View the official election results for NAB India 2025</p>
          <a 
            href="/NAB Election result 2025.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="election-banner-button"
            aria-label="View Election Results 2025 PDF"
          >
            <span className="election-icon">📊</span>
            View Election Results
          </a>
        </div>
      </div>

      <div className="iframe-container">
        <iframe
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FNabIndia1234&tabs=timeline&width=500&height=800&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
          className="facebook-iframe"
          frameBorder="0"
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          title="NAB India Facebook Feed"
        ></iframe>
      </div>
    </div>
  );
};

export default News;
